import React, { useContext, useState, useEffect } from 'react'
import { ProductContext } from '../../ProductProvider'
import config from '../../config.json'
import './MyProfile.css'
import { Modal, Button, Form } from 'react-bootstrap'
import { useSnackbar } from 'notistack'
import { updatePassword } from 'aws-amplify/auth';

export default function MyProfile() {
  const { loggedUser, myProfileImage, handleImageError, validateLogin } = useContext(ProductContext)
  const { enqueueSnackbar } = useSnackbar()
  const [showChangePwd, setShowChangePwd] = useState(false)
  const [currentPwd, setCurrentPwd] = useState('')
  const [newPwd, setNewPwd] = useState('')
  const [confirmPwd, setConfirmPwd] = useState('')
  const [changing, setChanging] = useState(false)

      useEffect(() => {
        if(loggedUser.isAuthenticated){
        //  fetchGalleryImages();
        }else{
          validateLogin();
        }
      }, [loggedUser])  
    

  const handleChangePassword = async () => {
    if (!currentPwd || !newPwd || !confirmPwd) {
      enqueueSnackbar('Please fill all password fields', { variant: 'warning' })
      return
    }
    if (newPwd !== confirmPwd) {
      enqueueSnackbar('New password and confirmation do not match', { variant: 'warning' })
      return
    }
    if (newPwd.length < 8) {
      enqueueSnackbar('New password must be at least 8 characters', { variant: 'warning' })
      return
    }

    setChanging(true)
    try {
     // const user = await Auth.currentAuthenticatedUser()
      await updatePassword({ oldPassword:currentPwd, newPassword: newPwd });
      enqueueSnackbar('Password changed successfully', { variant: 'success' })
      setShowChangePwd(false)
      setCurrentPwd('')
      setNewPwd('')
      setConfirmPwd('')
    } catch (err) {
      console.error('Change password error', err)
      const msg = err?.message || String(err)
      enqueueSnackbar('Error changing password: ' + msg, { variant: 'error' })
    } finally {
      setChanging(false)
    }
  }

  const imageSrc = (() => {
    if (!myProfileImage) return '/assets/img/profile-img.jpg'
    try {
      if (myProfileImage.startsWith('http')) return myProfileImage
    } catch (e) {}
    // fallback to configured profile URL
    return `${config.s3.profileUrl}${myProfileImage}`
  })()

  return (
    <main id="main" className="main">
      <div className="profile-wrapper container">
        <div className="profile-card card shadow-sm">
          <div className="row g-0">
            <div className="col-md-4 d-flex align-items-center justify-content-center p-4 bg-light">
              <div className="avatar-wrap text-center">
                <img
                  src={imageSrc}
                  alt={loggedUser?.name || 'Profile'}
                  className="profile-avatar"
                  onError={handleImageError}
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h2 className="mb-1 profile-name">{loggedUser?.name || 'Guest User'}</h2>
                    <div className="text-muted profile-subtitle">{loggedUser?.profile || ''}</div>
                  </div>
                  <div>
                    <span className={`badge ${loggedUser?.isAdmin ? 'bg-primary' : 'bg-secondary'}`}>{loggedUser?.isAdmin ? 'Admin' : 'User'}</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-6 mb-3">
                    <div className="info-item">
                      <i className="bi bi-envelope-fill me-2 info-icon"></i>
                      <div>
                        <div className="info-label">Email</div>
                        <div className="info-value">{loggedUser?.email || '—'}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 mb-3">
                    <div className="info-item">
                      <i className="bi bi-telephone-fill me-2 info-icon"></i>
                      <div>
                        <div className="info-label">Phone</div>
                        <div className="info-value">{loggedUser?.phone_number || loggedUser?.mobile || '—'}</div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 mb-3">
                    <div className="info-item">
                      <i className="bi bi-person-badge-fill me-2 info-icon"></i>
                      <div>
                        <div className="info-label">Profile</div>
                        <div className="info-value">{loggedUser?.profile || '—'}</div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 mb-3">
                    <div className="info-item">
                      <i className="bi bi-globe2 me-2 info-icon"></i>
                      <div>
                        <div className="info-label">Website</div>
                        <div className="info-value">{loggedUser?.website || '—'}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />

                <div className="d-flex flex-wrap gap-2">
                  <button className="btn btn-outline-primary" onClick={() => setShowChangePwd(true)}>Change Password</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showChangePwd} onHide={() => setShowChangePwd(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="currentPassword">
              <Form.Label>Current Password</Form.Label>
              <Form.Control type="password" value={currentPwd} onChange={e => setCurrentPwd(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="newPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control type="password" value={newPwd} onChange={e => setNewPwd(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="confirmPassword">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control type="password" value={confirmPwd} onChange={e => setConfirmPwd(e.target.value)} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowChangePwd(false)}>Cancel</Button>
          <Button variant="primary" disabled={changing} onClick={handleChangePassword}>{changing ? 'Changing...' : 'Change Password'}</Button>
        </Modal.Footer>
      </Modal>
    </main>
  )
}

